import React from 'react';

import { RadioButton as RadioButtonStyled, RadioButtonItem, Label } from './RadioButtonStyled';

type Props = {
  checked?: boolean;
  disabled?: boolean;
  onClick: (isChecked: boolean) => void;
};

export const RadioButton: React.FC<Props> = ({ checked = false, disabled = false, children, onClick }) => {
  return (
    <RadioButtonStyled>
      <RadioButtonItem
        tabIndex="0"
        checked={checked}
        disabled={disabled}
        onClick={() => onClick(!checked)}
      />
      <Label onClick={() => onClick(!checked)}>{children}</Label>
    </RadioButtonStyled>
  );
};